'use client';

import type { FilePreviewData } from './FilePreview';
import { useEffect, useState } from 'react';
import { FilePreview } from './FilePreview';

export function FilePreviewListener() {
  const [previewFile, setPreviewFile] = useState<FilePreviewData | null>(null);

  useEffect(() => {
    // Add event listener for custom 'openFilePreview' event
    const handleOpenFilePreview = (event: CustomEvent<FilePreviewData>) => {
      setPreviewFile(event.detail);
    };

    window.addEventListener('openFilePreview', handleOpenFilePreview as EventListener);

    // Cleanup
    return () => {
      window.removeEventListener('openFilePreview', handleOpenFilePreview as EventListener);
    };
  }, []);

  const handleClosePreview = () => {
    setPreviewFile(null);
  };

  return (
    <FilePreview
      file={previewFile}
      onClose={handleClosePreview}
    />
  );
}
